import { render } from "./EditableList.vue?vue&type=template&id=57c088fe&scoped=true"
import script from "./EditableList.vue?vue&type=script&lang=js"
export * from "./EditableList.vue?vue&type=script&lang=js"

import "./EditableList.vue?vue&type=style&index=0&id=57c088fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c088fe"]])

export default __exports__